import { useContext } from 'react';

import { ProctoringDetailsModalContext } from './proctoring-details-modal-provider';

function useProctoringDetailsModal() {
  const context = useContext(ProctoringDetailsModalContext);

  if (!context) {
    throw new Error(
      'useProctoringDetailsModal must be used within a ProctoringDetailsModalProvider',
    );
  }

  return context;
}

export { useProctoringDetailsModal };
